// #region Imports

/* Telestream */
import {
  SET_ANNOTATION_SHAPES_SELECTED,
  SET_ANNOTATION_TOOLS_ARE_SHOWN,
  SET_ANNOTATION_TOOL,
  SET_ANNOTATION_TOOLS_COLOR,
  SET_BOTTOM_TABS, SET_TOP_TABS,
  SET_COLUMNS_SPLIT,
  SET_FILE_BROWSER_IS_OPEN,
  SET_FILE_BROWSER_IS_HIDDEN,
  SET_INFO_COLUMN_SPLIT,
  SET_MEDIA_COLUMN_SPLIT,
  SET_QUICKVIEW_IS_ENABLED,
  SET_ANNOTATION_BEING_EDITED,
  SET_REPLY_BEING_EDITED,
  SET_IS_WAVEFORM_FLAG_CLICKED,
  SET_IS_ANNOTATION_FLAG_CLICKED,
  SET_WAVEFORM_ZOOM_LEVEL
} from '@/utils/mutation-types';
import {
  RESIZE_COLUMNS,
  RESIZE_INFO_COLUMN,
  RESIZE_MEDIA_COLUMN,
  SELECT_TOP_VISIBLE_TABS,
  SELECT_BOTTOM_VISIBLE_TABS,
  RESET_TABS,
  RESTORE_LAYOUT,
  ZOOM_ON_WAVEFORM
} from '@/utils/action-types';
import { 
  restoreColumnsSplit,
  storeColumnsSplit,
  restoreInfoColumnSplit,
  storeInfoColumnSplit,
  restoreMediaColumnSplit,
  storeMediaColumnSplit,
  storeBottomTabs,
  storeTopTabs,
  TOP_TABS_DEFAULT,
  BOTTOM_TABS_DEFAULT,
  COLUMNS_SPLIT_DEFAULT,
  MEDIA_COLUMN_SPLIT_DEFAULT,
  INFO_COLUMN_SPLIT_DEFAULT
} from './utilities/persistence.utils';
import {
  extractLayoutFromQueryParams
} from './utilities/layout.utils';

// #endregion Imports

export const ui = {

  // #region State

  state: {
    isFileBrowserOpen:        false,
    isFileBrowserHidden:      false,
    isQuickViewEnabled:       false,
    columnsSplitPercent:      restoreColumnsSplit(),
    mediaColumnSplitPercent:  restoreMediaColumnSplit(),
    infoColumnSplitPercent:   restoreInfoColumnSplit(),
    layout:                   extractLayoutFromQueryParams(),
    areAnnotationToolsShown:  false,
    annotationTool:           'ellipse',
    annotationToolsColor:     'hsl(200,100%,45.88235294117647%)',
    annotationShapesSelected: [],
    annotationBeingEdited:    undefined,
    replyBeingEdited:         undefined,
    isWaveformFlagClicked:    false,
    isAnnotationFlagClicked:  false,
    waveformZoomLevel:        1
  },

  // #endregion State

  // #region Mutations

  mutations: {
    [SET_FILE_BROWSER_IS_OPEN](state, isOpen) {
      state.isFileBrowserOpen = isOpen;
    },

    [SET_FILE_BROWSER_IS_HIDDEN](state, isHidden) {
      state.isFileBrowserHidden = isHidden;
    },

    [SET_QUICKVIEW_IS_ENABLED](state, isEnabled) {
      state.isQuickViewEnabled = isEnabled;
    },

    [SET_COLUMNS_SPLIT](state, percentage) {
      state.columnsSplitPercent = percentage;
    },

    [SET_INFO_COLUMN_SPLIT](state, percentage) {
      state.infoColumnSplitPercent = percentage;
    },

    [SET_MEDIA_COLUMN_SPLIT](state, percentage) {
      state.mediaColumnSplitPercent = percentage;
    },

    [SET_TOP_TABS](state, tabs) {
      state.layout.topTabs.tabs = tabs;
    },

    [SET_BOTTOM_TABS](state, tabs) {
      state.layout.bottomTabs.tabs = tabs;
    },

    [SET_ANNOTATION_TOOLS_ARE_SHOWN](state, areShown) {
      state.areAnnotationToolsShown = areShown;
    },

    [SET_ANNOTATION_TOOL](state, tool) {
      state.annotationTool = tool;
    },

    [SET_ANNOTATION_TOOLS_COLOR](state, color) {
      state.annotationToolsColor = color;
    },

    [SET_ANNOTATION_SHAPES_SELECTED](state, shapes) {
      state.annotationShapesSelected = shapes;
    },

    [SET_ANNOTATION_BEING_EDITED](state, annotationId) {
      state.annotationBeingEdited = annotationId;
    },

    [SET_REPLY_BEING_EDITED](state, replyId) {
      state.replyBeingEdited = replyId;
    },

    [SET_IS_WAVEFORM_FLAG_CLICKED](state, value) {
      state.isWaveformFlagClicked = value;
    },

    [SET_IS_ANNOTATION_FLAG_CLICKED](state, value) {
      state.isAnnotationFlagClicked = value;
    },

    [SET_WAVEFORM_ZOOM_LEVEL](state, value) {
      state.waveformZoomLevel = value;
    }

  },

  // #endregion Mutations

  // #region Actions

  actions: {

    [RESIZE_COLUMNS](context, percentage) {
      context.commit(SET_COLUMNS_SPLIT, percentage);
      storeColumnsSplit(percentage);
    },

    [RESIZE_INFO_COLUMN](context, percentage) {
      context.commit(SET_INFO_COLUMN_SPLIT, percentage);
      storeInfoColumnSplit(percentage);
    },

    [RESIZE_MEDIA_COLUMN](context, percentage) {
      context.commit(SET_MEDIA_COLUMN_SPLIT, percentage);
      storeMediaColumnSplit(percentage);
    },

    [RESTORE_LAYOUT](context) {
      context.dispatch(RESIZE_COLUMNS, COLUMNS_SPLIT_DEFAULT);
      context.dispatch(RESIZE_INFO_COLUMN, INFO_COLUMN_SPLIT_DEFAULT);
      context.dispatch(RESIZE_MEDIA_COLUMN, MEDIA_COLUMN_SPLIT_DEFAULT);
    },

    [SELECT_TOP_VISIBLE_TABS](context, tabs) {
      context.commit(SET_TOP_TABS, tabs);
      storeTopTabs(tabs);
    },

    [SELECT_BOTTOM_VISIBLE_TABS](context, tabs) {
      context.commit(SET_BOTTOM_TABS, tabs);
      storeBottomTabs(tabs);
    },

    [RESET_TABS](context) {
      context.commit(SET_TOP_TABS, TOP_TABS_DEFAULT);
      storeTopTabs(TOP_TABS_DEFAULT);

      context.commit(SET_BOTTOM_TABS, BOTTOM_TABS_DEFAULT);
      storeBottomTabs(BOTTOM_TABS_DEFAULT);
    },

    [ZOOM_ON_WAVEFORM](context, level) {
      context.commit(SET_WAVEFORM_ZOOM_LEVEL, level);
    }
  }

  // #endregion Actions

};
